import { SidebarLayoutContent } from './SidebarLayoutContent';
import { SidebarLayoutSidebar } from './SidebarLayoutSidebar';

export const Sidebar = SidebarLayoutSidebar;
export const Content = SidebarLayoutContent;

export * from './SidebarLayout';
export { SidebarLayoutContent, SidebarLayoutSidebar };
